import React, {
    useMemo, useState,
} from 'react'
import PropTypes from 'prop-types'
import LocationContext from './LocationContext'

const propTypes = { children: PropTypes.element.isRequired }

const LocationProvider = ({ children }) => {
    const [
        currentLocation,
        setCurrentLocation,
    ] = useState(
        {
            locationId: null,
            locationName: null,
        },
    )

    const value = useMemo(() => {
        return {
            location: currentLocation,
            setLocation: setCurrentLocation,
        }
    }, [currentLocation])

    return (
        <LocationContext.Provider
            value={value}
        >
            {children}
        </LocationContext.Provider>
    )
}

LocationProvider.propTypes = propTypes

export default LocationProvider
